(function () {
  'use strict';

  function setup() {
    var viewer = document.getElementById('cylindo-viewer');
    if (!viewer) return;

    var viewerWrapper = document.getElementById('cylindo-viewer-wrapper');
    var galleryFallback = document.getElementById('cylindo-gallery-fallback');
    var dataEl = document.getElementById('cylindo-variant-data');
    var variantData = {};
    try {
      if (dataEl) variantData = JSON.parse(dataEl.textContent);
    } catch (e) { /* leave as empty map */ }

    console.log('cylindo-viewer.js setup', { variantCount: Object.keys(variantData).length, initialCode: viewer.getAttribute('code') });

    var inFallback = false;
    var lastVariantId = null;

    function showGallery() {
      viewerWrapper.classList.add('cylindo-hidden');
      if (!galleryFallback) return;
      galleryFallback.classList.remove('cylindo-gallery-hidden');
      // Clear the inline display:none from Liquid (used to prevent the
      // gallery from flashing on initial page load before CSS parses).
      galleryFallback.style.display = '';

      // Flickity was initialized at page load while the gallery was
      // display:none. That means two things broke:
      //   1) the main cell measured zero width and never laid out, and
      //   2) product.js's thumbnail click binding filters by clientWidth>0,
      //      so none of the thumbnails got click handlers either.
      // reInit() destroys and recreates Flickity from scratch, which fixes
      // both at once (re-measures AND re-binds thumb clicks).
      requestAnimationFrame(function () {
        var slider = galleryFallback.querySelector('.product-images');
        if (!slider) return;
        if (typeof slider.reInit === 'function') {
          slider.reInit();
        } else if (window.Flickity) {
          var flkty = Flickity.data(slider);
          if (flkty) flkty.resize();
        }
        // After Flickity is back in a good state, seek to the current
        // variant's featured media (Shopify's "assign variant a photo"
        // behavior — normally handled by product.js's VariantSelects, but
        // that flow doesn't run in this theme).
        if (lastVariantId) updateFallbackGalleryForVariant(lastVariantId);
      });
    }

    // Replicates product.js's setActiveMedia() for the fallback gallery,
    // since this theme renders variant-selects as a plain <div> (not the
    // custom element), so its onVariantChange → updateMedia flow never
    // fires. We listen for the change ourselves and seek the slider here.
    function updateFallbackGalleryForVariant(variantId) {
      if (!galleryFallback) return;

      var productJsonEl = document.querySelector('[data-product-json]');
      if (!productJsonEl) return;

      var variant;
      try {
        var product = JSON.parse(productJsonEl.textContent);
        variant = (product.variants || []).find(function (v) {
          return String(v.id) === String(variantId);
        });
      } catch (e) { return; }

      if (!variant || !variant.featured_media) return;

      var info = getSectionInfo();
      if (!info || !info.sectionId) return;

      var slider = galleryFallback.querySelector('.product-images');
      var thumbnails = galleryFallback.querySelector('#Product-Thumbnails');
      if (!slider) return;

      var mediaId = variant.featured_media.id;
      var slideSelector = '#Slide-' + info.sectionId + '-' + mediaId;
      var thumbSelector = '#Thumb-' + info.sectionId + '-' + mediaId;

      // Seek the slider. selectCell silently no-ops if the slide doesn't
      // exist; wrap in try/catch in case Flickity is mid-teardown.
      try {
        if (typeof slider.selectCell === 'function') {
          slider.selectCell(slideSelector);
        } else if (window.Flickity) {
          var flkty = Flickity.data(slider);
          if (flkty) flkty.selectCell(slideSelector);
        }
      } catch (e) { /* ignore */ }

      // Update active-thumb visual state to match.
      if (thumbnails) {
        thumbnails.querySelectorAll('.product-thumbnail').forEach(function (t) {
          t.classList.remove('is-initial-selected', 'is-active');
        });
        var activeThumb = thumbnails.querySelector(thumbSelector);
        if (activeThumb) {
          activeThumb.classList.add('is-initial-selected');
          activeThumb.classList.add('is-active');
        }
      }
    }
    function showViewer() {
      viewerWrapper.classList.remove('cylindo-hidden');
      if (galleryFallback) galleryFallback.classList.add('cylindo-gallery-hidden');
    }

    function attachFallbackListener(el) {
      el.addEventListener('fallback', function () {
        console.log('cylindo fallback fired');
        inFallback = true;
        showGallery();
        hideLoading();
      });
    }
    attachFallbackListener(viewer);

    // Loading overlay control. Cylindo v4 doesn't publicly document the
    // exact "ready" event name, so we listen on several plausible ones and
    // also keep a safety timeout so the overlay can never get stuck.
    var loadingTimeout = null;
    function getOverlay() {
      return viewerWrapper && viewerWrapper.querySelector('.cylindo-loading-overlay');
    }
    function showLoading() {
      var overlay = getOverlay();
      if (overlay) overlay.classList.add('is-loading');
      if (loadingTimeout) clearTimeout(loadingTimeout);
      loadingTimeout = setTimeout(hideLoading, 4000);
    }
    function hideLoading() {
      var overlay = getOverlay();
      if (overlay) overlay.classList.remove('is-loading');
      if (loadingTimeout) { clearTimeout(loadingTimeout); loadingTimeout = null; }
    }
    function attachLoadListeners(el) {
      ['loaded', 'load', 'ready', 'loadcomplete', 'image-loaded', 'frame-loaded']
        .forEach(function (ev) { el.addEventListener(ev, hideLoading); });
    }
    attachLoadListeners(viewer);

    // Initialize last-known variant ID from the form's hidden input.
    var initialIdInput = document.querySelector('input[name="id"]');
    if (initialIdInput) lastVariantId = initialIdInput.value;

    // Look for any element exposing data-section / data-url; the theme renders
    // these as plain divs (variant-selects-XXX) rather than the custom-element
    // tags from product.js.
    function getSectionInfo() {
      var el =
        document.querySelector('variant-selects, variant-radios') ||
        document.querySelector('[id^="variant-selects-"], [id^="variant-radios-"]') ||
        document.querySelector('.optionValueSelectors');
      if (!el) return null;
      var sectionId = el.dataset.section || el.dataset.sectionId ||
                       (el.id && el.id.replace(/^variant-(selects|radios)-/, ''));
      var productUrl = el.dataset.url || el.dataset.productUrl || window.location.pathname.split('?')[0];
      return { sectionId: sectionId, productUrl: productUrl };
    }

    function reloadViewerSection(variantId) {
      var info = getSectionInfo();
      if (!info || !info.sectionId) {
        console.warn('cylindo: could not resolve section info for reload');
        return;
      }

      var fetchUrl = info.productUrl + '?variant=' + variantId + '&section_id=' + info.sectionId;
      console.log('cylindo reloading section:', fetchUrl);

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshWrapper = doc.getElementById('cylindo-viewer-wrapper');
          if (!freshWrapper) {
            console.warn('cylindo: #cylindo-viewer-wrapper not found in fetched section');
            return;
          }
          if (!viewerWrapper) return;

          viewerWrapper.outerHTML = freshWrapper.outerHTML;

          viewerWrapper = document.getElementById('cylindo-viewer-wrapper');
          if (viewerWrapper) {
            viewer = viewerWrapper.querySelector('#cylindo-viewer');
            if (viewer) {
              attachFallbackListener(viewer);
              attachLoadListeners(viewer);
            }
          }
          inFallback = false;
          // Re-hide the gallery — it was made visible by a prior fallback
          // and the section reload only swaps the viewer wrapper, not the
          // gallery wrapper.
          showViewer();

          // Refresh the color fieldsets in the variant picker. For Hydeline
          // products, swatches are grouped Quickship / Made-To-Order based on
          // the variant's quickship metafield — which depends on the
          // currently selected size. After a size change, the fresh server-
          // rendered fieldsets contain the right grouping for the new size.
          // This is a no-op for non-Hydeline products (the rendering is
          // identical to what was already there).
          var freshFieldsets = doc.querySelectorAll('.product-form__input--color');
          var currentFieldsets = document.querySelectorAll('.product-form__input--color');
          var pairs = Math.min(freshFieldsets.length, currentFieldsets.length);
          for (var i = 0; i < pairs; i++) {
            currentFieldsets[i].outerHTML = freshFieldsets[i].outerHTML;
          }
        })
        .catch(function (e) { console.warn('cylindo section reload failed', e); });
    }

    // Rewrite each thumb image URL with a new UPHOLSTERY code. Used when
    // the user switches between two Cylindo-supported upholsteries on the
    // same size — no section reload happens in that path, so the strip
    // would otherwise keep showing the previous upholstery's thumbnails.
    function updateThumbsUpholstery(newUpholstery) {
      var strip = document.getElementById('cylindo-thumb-strip');
      if (!strip || !newUpholstery) return;
      var customerId = strip.dataset.customerId;
      var code = strip.dataset.code;
      strip.dataset.upholstery = newUpholstery;
      strip.querySelectorAll('.cylindo-thumb').forEach(function (btn) {
        var frame = btn.dataset.frame;
        var img = btn.querySelector('img');
        if (img && frame && customerId && code) {
          img.src = 'https://content.cylindo.com/api/v2/' + customerId +
            '/products/' + code +
            '/frames/' + frame +
            '/' + code + '.JPG?background=FFFFFF&feature=UPHOLSTERY:' +
            encodeURIComponent(newUpholstery) + '&size=128';
        }
      });
    }

    function handleVariantId(variantId) {
      if (!variantId || variantId === lastVariantId) return;
      lastVariantId = variantId;

      var data = variantData[variantId];
      console.log('cylindo variant detected', variantId, data);

      // Keep the fallback gallery in sync with the variant's featured
      // media on every change, regardless of whether we end up showing it.
      updateFallbackGalleryForVariant(variantId);

      if (!data || !data.code) {
        inFallback = true;
        showGallery();
        return;
      }

      var currentCode = viewer && viewer.getAttribute('code');
      var codeChanged = currentCode !== String(data.code);

      if (codeChanged || inFallback) {
        showLoading();
        reloadViewerSection(variantId);
      } else {
        // Same Cylindo product (same size), different upholstery.
        // The integration updates the viewer's features automatically;
        // we just need to refresh our custom thumb strip's URLs.
        showLoading();
        updateThumbsUpholstery(data.upholstery);
      }
    }

    // Custom thumbnail strip — clicking a thumb rotates the Cylindo viewer
    // to that frame. Cylindo v4 doesn't publicly document a rotation API,
    // so we try a few likely paths (property + attribute) and accept
    // whichever one the current viewer build honors.
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('.cylindo-thumb');
      if (!btn) return;
      var frame = parseInt(btn.dataset.frame, 10);
      if (!frame || !viewer) return;

      try { viewer.frame = frame; } catch (e) {}
      try { viewer.currentFrame = frame; } catch (e) {}
      viewer.setAttribute('frame', String(frame));

      var strip = btn.closest('.cylindo-thumb-strip');
      if (strip) {
        strip.querySelectorAll('.cylindo-thumb').forEach(function (t) {
          t.classList.toggle('is-active', t === btn);
        });
      }
    });

    // Primary path: catch every `change` event in the product area and read
    // the new variant id off the form's hidden input. This mirrors how
    // high-variant-options.js and cylindo-shopify-integration both react to
    // raw input changes, instead of relying on the theme's custom
    // product:variant-change event (which isn't dispatched in this flow).
    document.addEventListener('change', function (event) {
      // Wait one tick so the theme's variant-resolution code has time to
      // update input[name="id"] with the new variant id.
      setTimeout(function () {
        var idInput = document.querySelector('input[name="id"]');
        if (!idInput) return;
        handleVariantId(idInput.value);
      }, 0);
    });

    // Secondary path: keep listening for product:variant-change in case the
    // theme dispatches it in some other flow.
    document.addEventListener('product:variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && variant.id) handleVariantId(String(variant.id));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
